module.exports = __webpack_public_path__ + "img/logo profile priority-66.a1720fc1.jpg";